<template>
  <div class="container" v-if="aiAgent.length">
    <home-title
      title="智能应用"
      link2="/ai/agent"
      :icon="require('@/assets/images/home/home_title/icon11_1.svg')"
    ></home-title>
    <div class="langchain_list">
      <div
        class="langchain_item ta3"
        v-for="e in aiAgent"
        :key="e.id"
        @click="openChatAI(e.aigc_agent_id)"
      >
        <div class="langchain_cover">
          <img
            :src="$prefixSrc(e.ai_agent_avatar)"
            alt=""
            class="cover pic_error"
          />
        </div>
        <div class="langchain_info">
          <div class="langchain_name toh">{{ e.ai_agent_name }}</div>
          <div class="langchain_intro_box">
            <p class="langchain_intro toh2">
              {{ e.ai_agent_description }}
            </p>
          </div>

            <!-- <div class="langchain_bottom">
              <div class="langchain_num">
                <i class="iconfont icon-hot"></i>
                <span>{{ e.use_count }}</span>
              </div>
            </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
import { mapGetters } from "vuex";
import { getToken, getNick } from "@/utils/auth.js";

export default {
  name: "aiAgent",
  components: { homeTitle },
  props: {
    aiAgent: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      token: getToken(),
      nick: getNick(),
    };
  },
  // computed: {
  //   ...mapGetters(["token", "name"]),
  // },
  mounted() {},
  methods: {
    openChatAI(id) {
      if(!this.token){
        this.$emit('show-login', 'aiAgent');
        return
      }
      this.$router.push(`ai/agent/${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 36px 0 50px;
  .langchain_list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px 13px;

    .langchain_item {
      padding: 20px;
      padding-bottom: 0;
      width: 24.1%;
      // height: 140px;
      height: 120px;
      border-radius: 18px;
      background: #fff;
      display: flex;
      gap: 20px;
      cursor: pointer;

      &:hover {
        box-shadow: 0px 8px 20px 0px #e1e8ef;
      }

      .langchain_cover {
        .cover {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          font-size: 24px;
        }
      }

      .langchain_info {
        flex: 1;
        overflow: hidden;

        .langchain_name {
          font-weight: bold;
          font-size: 14px;
          color: #333;
          line-height: 18px;
          margin-bottom: 10px;
        }

        .langchain_intro_box {
          height: 28px;
          margin-bottom: 20px;

          .langchain_tooltip {
            max-width: 288px;
            width: 100%;
            text-align: justify;
          }

          .langchain_intro {
            font-size: 12px;
            color: #666;
            line-height: 14px;
            display: -webkit-inline-box;
            text-align: justify;
          }
        }

        .langchain_bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          color: #aaa;

          .langchain_num {
            display: flex;
            align-items: center;
            gap: 8px;
            i {
              font-size: 14px;
              color: #aaa;
            }
          }
        }
      }
    }
  }
}
</style>
